import Vue from 'vue'
import Axios from 'axios'
import Qs from 'qs'
import setting from '@/setting'

var axios = Axios.create({
　baseURL: setting.apiBaseURL,
　timeout: 1000 * 60 * 60,  //请求超时时间
})
axios.defaults.withCredentials = true;

var axiosdownload = Axios.create({
　	baseURL: setting.apiBaseURL,
　	timeout: 1000 * 60 * 60,  //请求超时时间
	responseType: 'blob'
})

axios.interceptors.request.use(function(request){
	request.credentials = true;

	//header传值，例如：Authorization
	var jwtHeader = window.AbJwtSetting.getHeader();
	if (jwtHeader) {
		if (!request.headers) {
			request.headers = {};
		}
		request.headers[window.AbJwtSetting.headerName] = jwtHeader;
	}
	return request;
})

// 设置通用的拦截器
axios.interceptors.response.use(function(response){
	if(response.data && !response.data.isOk && response.data.code==="401" ){
		//Vue.prototype.$Message.error("登录超时，请重新登录");
		 return response;
	  }
	  if(response.data && !response.data.isOk && response.data.code==="403" ){
		  console.info(response);
		  Vue.prototype.$Message.error("访问受限！");
		  return response;
	  }
    return response;
},function(error){
	//通用异常
    return Promise.reject(error);
});


// Http Util 基础服务
 var HttpUtil = {
	  get : function (url) {
	  	 return new Promise((resolve, reject) => {
		    axios.get(url)
		    	.then(response => {
		    		resolve(response.data);
		    	})
		    	.catch(error => {
				    console.log("请求失败：",error);
		    		reject(error)
		    	})
		  })
	  },
	  post : function(url,data){
	  	if(!data) data={};

	  	 return new Promise((resolve, reject) => {
		    axios.post(url,data)
		    	.then(response => {
		    		resolve(response.data) ;
		    	})
		    	.catch(error => {
				    console.log("请求失败：",error);
		    	reject(error)
		    	})
		  })

	  },
	 postExcel: function (url, data) {
		 if (!data) data = {};
		 return new Promise((resolve, reject) => {
			 axios.post(url, data, {
				 responseType: 'blob'
			 })
				 .then(response => {
					 let fileResInfo = response.headers['content-disposition']
					 resolve(response.data);
				 })
				 .catch(error => {
					 console.log('请求失败：', error);
					 reject(error)
				 })
		 })

	 },
	  // form-data格式化
	  postForm : function(url,data){
	  	if(!data) data={};
	  	return new Promise((resolve, reject) => {
		    axios.post(url, data,{transformRequest:this.jsonToFormData,headers:{"Content-Type":"application/x-www-form-urlencoded; charset=utf-8"} })
		    	.then(response => {
		    		resolve(response.data) ;
		    	})
		    	.catch(error => {
				    console.log("请求失败：",error);
		    	reject(error)
		    	})
		  })
	  }

	  ,jsonToFormData:function(data){
	  	data = Qs.stringify(data,{arrayFormat: 'brackets'});// qs.stringify(params)
			return data;
	  },
	  postDownloadRes : function(url,data){
		if(!data) data={};

		 return new Promise((resolve, reject) => {
			axiosdownload.post(url,data)
			  .then(response => {
				  resolve(response) ;
			  })
			  .catch(error => {
				console.log("请求失败：",error);
			  	reject(error)
			  })
		})
	},
 }

export default {
	// 全局安装时候
  install (Vue) {
    Vue.abHttpUtil = HttpUtil;
    Vue.prototype.abHttpUtil = HttpUtil;
  }
}
